import { Box, Grid, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { fetchNotificationCount } from "../../../action/searchFilterAction"
import AHMIS, { API_URL } from "../../../api/api"
import AddAlertMessage from "../../../components/alert/Alert"
import CustomReactSelect from "../../../components/custom-react-select/CustomReactSelect"
import DeleteRegisterRecordConformation from "../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation"
import CustomModal from "../../../components/modal/CustomModal"
import MulDartaaSelect from "../../../components/mul-dartaa-select/MulDartaaSelect"
import PendingPatientList from "../../../components/pending-patient-list/PendingPatientList"
import RegisterHeader from "../../../components/register-header/RegisterHeader"
import RegisterNotificationBell from "../../../components/notification/RegisterNotificationBell"
import { useNotificationAccept } from "../../../components/notification/useNotificationAccept"
import { AppMisc } from "../../../misc/appMisc"
import { ERROR, PRAKRITI, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS, THERAPEUTIC, YOG_SEWA_VIVARAN, NOTIFICATION_ACCEPTED } from "../../../utils/constants"
import { MUL_DARTA_NUMBERS_LIST } from "../../../utils/constants/forms"
import { DateUtils } from "../../../utils/dateUtils"
import { SessionStorage } from "../../../utils/storage/sessionStorage"
import TherapeuticYogaSewaRegister from "../../users/components/register/therapeutic-yoga-sewa-register/TherapeuticYogaSewaRegister"
import { fetchPendingNotifications } from "../../../components/notification/notificationService"

const TherapeuticYogaSewaForm = () => {
  const [modalTitle, setModalTitle] = useState("उपचारात्मक योग सेवा रजिष्टर")
  const [showTherapeuticYogaModal, setShowTherapeuticYogaModal] = useState(false)
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [therapeuticTableData, setTherapeuticTableData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [showtherapeuticSewaDeleteModal, setShowtherapeuticSewaDeleteModal] = useState(false);
  const [therapeuticSewaDeleteId, setTherapeuticSewaDeleteId] = useState(null);
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);
  const dispatch = useDispatch();
  const [pendingPatientList, setPendingPatientList] = useState([])
  const { handleAccept: handleNotificationAccept, addNotificationId } = useNotificationAccept({
    reset,
    setModalOpen: setShowTherapeuticYogaModal,
    setModalDefaultValues,
    transform: (data) => {
      if (data.palikaName) {
        data.palikaName = AppMisc.getMunicipalityName(data.palikaName);
      }
      return data;
    },
  });

  useEffect(() => {
    register("yopVivaran")
    register("nature")
  }, [register]);

  const openTherapeuticYogaModal = () => {
    setShowTherapeuticYogaModal(true);
  }

  const closeTherapeuticYogaModal = () => {
    setShowTherapeuticYogaModal(false)
    setModalDefaultValues(true);
    reset({
      vyadhi: "",
      yogSewa: "",
      yogName: "",
      type: "",
      patientFirstName: '',
      patientLastName: '',
      age: '',
      gaunOrTole: '',
      nid: '',
      phoneNumber: '',
      wardNumber: '',
      nature: '',
      sewaDartaaNumber: "",
    })
  }

  const handleCustomReactSelectChange = (name, value) => {
    setValue(name, value);
  }

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  }

  const submitTherapeuticYogSewa = (data) => {
    const isFromNotification = !!modalDefaultValues?.notificationId;
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    data = addNotificationId(data);
    AHMIS.post(API_URL.therapeuticSewaRegister, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeTherapeuticYogaModal();
          therapeuticPendingPatient();
          getTherapeuticData(fromDate, toDate)
          if (isFromNotification) {
            dispatch(fetchNotificationCount(THERAPEUTIC));
          }
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    if (fromDate && toDate) {
      getTherapeuticData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])

  const getTherapeuticData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.therapeuticSewaRegister}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setTherapeuticTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.totalSize)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const therapeuticSewaEdit = (id) => {
    AHMIS.get(API_URL.therapeuticSewaRegister + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        setModalDefaultValues(data);
        setShowTherapeuticYogaModal(true);
        if (data) {
          Object.keys(data).forEach((key) => {
            setValue(key, data[key]);
          });
        }
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const closetherapeuticSewaDeleteModal = () => {
    setShowtherapeuticSewaDeleteModal(false);
    setTherapeuticSewaDeleteId(null);
    reset();
  }

  const onDeletetherapeuticSewaRow = (id) => {
    setShowtherapeuticSewaDeleteModal(true);
    setTherapeuticSewaDeleteId(id);
  }

  const deletetherapeuticSewaRow = (data) => {
    AHMIS.delete(API_URL.therapeuticSewaRegister + "/" + therapeuticSewaDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowtherapeuticSewaDeleteModal(false);
          setTherapeuticSewaDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getTherapeuticData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getTherapeuticData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=4&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
    therapeuticPendingPatient()
  }, [])

  const therapeuticPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"4"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${THERAPEUTIC}`
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      setPendingPatientList(jsondata.data)
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  return (
    <>
      <Box marginTop={2}>
        <RegisterHeader
          registerTitle="उपचारात्मक योग सेवा रजिष्टर"
          handleModalOpen={openTherapeuticYogaModal}
          getRegisterData={getTherapeuticData}
          onHeaderParamChange={onHeaderParamChange}
          fromDateDefaultFormat
          lazyLoading
          showSearchField
          rightElement={<RegisterNotificationBell targetRegister={THERAPEUTIC} onAccept={handleNotificationAccept} />}
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showTherapeuticYogaModal}
        onModalSubmit={handleSubmit(submitTherapeuticYogSewa)}
        onModalClose={closeTherapeuticYogaModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            handleSelectedDartaaMitiChange={handleDateChange}
            registerConstant={THERAPEUTIC}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="व्याधी"
                size="small"
                variant="outlined"
                name="vyadhi"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.vyadhi}
                {...register("vyadhi")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="प्रकृति"
                name="nature"
                onChange={handleCustomReactSelectChange}
                options={PRAKRITI}
                defaultValue={modalDefaultValues?.nature}
                register={register}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="योगको विवरण"
                name="yogSewa"
                onChange={handleCustomReactSelectChange}
                options={YOG_SEWA_VIVARAN}
                defaultValue={modalDefaultValues?.yogSewa}
                isMulti
                register={register}
                required
              />
              {errors?.yogSewa && errors.yogSewa?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="योगको नाम"
                size="small"
                variant="outlined"
                name="yogName"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.yogName}
                {...register("yogName")}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList?.totalSize > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowTherapeuticYogaModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showtherapeuticSewaDeleteModal}
        closeDeleteModel={closetherapeuticSewaDeleteModal}
        deleteRecord={deletetherapeuticSewaRow}
      />
      <TherapeuticYogaSewaRegister
        onEditRow={therapeuticSewaEdit}
        tableData={therapeuticTableData}
        deleteRow={onDeletetherapeuticSewaRow}
        totalSize={totalSize}
      />
    </>
  )
}

export default TherapeuticYogaSewaForm;